import { ViewCancelForm } from '@actions/novaOrdemActions';
import { CancelarPedido } from '@actions/pedidosActions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { Form, Input, Modal } from 'antd';

type FormData = {
  motivo: string;
};

function CancelPedidoModalRedux() {
  const dispatch = useAppDispatch();
  const { cancelForm } = useAppSelector((state) => state.novaOrdem);
  const { cancelandoPedido } = useAppSelector((state) => state.pedidos);
  const [form] = Form.useForm<FormData>();
  const handleSubmit = (values: FormData) => {
    dispatch(CancelarPedido({ id: cancelForm.id, motivo: values.motivo, cod: cancelForm.cod }));
  };
  return (
    <Modal
      open={cancelForm.visible}
      title="Razão do cancelamento/substituição"
      onCancel={() => {
        dispatch(ViewCancelForm({ id: null, view: false, replace: false, cod: null }));
      }}
      okButtonProps={{ loading: cancelandoPedido }}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item rules={[{ required: true, message: 'Campo obrigatório' }]} name="motivo">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default CancelPedidoModalRedux;
